/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoSlackIcon16Regular = forwardRef('LogoSlackIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4 3a1.5 1.5 0 0 0 1.5 1.5h1.167C6.85 4.5 7 4.35 7 4.167V3a1.5 1.5 0 1 0-3 0Z" }),
        React.createElement("path", { d: "M9.25 1.5C8.56 1.5 8 2.06 8 2.75v3a1.25 1.25 0 1 0 2.5 0v-3c0-.69-.56-1.25-1.25-1.25Z" }),
        React.createElement("path", { d: "M13 4a1.5 1.5 0 0 0-1.5 1.5v1.167c0 .184.15.333.333.333H13a1.5 1.5 0 0 0 0-3Z" }),
        React.createElement("path", { d: "M2.75 8a1.25 1.25 0 1 1 0-2.5h3a1.25 1.25 0 1 1 0 2.5h-3Z" }),
        React.createElement("path", { d: "M8 13.25a1.25 1.25 0 1 1-2.5 0v-3a1.25 1.25 0 1 1 2.5 0v3Z" }),
        React.createElement("path", { d: "M3 12a1.5 1.5 0 0 0 1.5-1.5V9.333A.333.333 0 0 0 4.167 9H3a1.5 1.5 0 1 0 0 3Z" }),
        React.createElement("path", { d: "M13.25 8a1.25 1.25 0 1 1 0 2.5h-3a1.25 1.25 0 1 1 0-2.5h3Z" }),
        React.createElement("path", { d: "M12 13a1.5 1.5 0 0 0-1.5-1.5H9.333a.333.333 0 0 0-.333.333V13a1.5 1.5 0 0 0 3 0Z" })));
});
